export const TOKEN = 'token'; // auth token
export const USER_PERMISSIONS = 'user_permissions';
export const USER_NODE = 'user_node';
export const LG_PATH = 'lg-path';
